(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glo-instant-price')) {
    customElements.define('glo-instant-price', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('.hdt-product-info__list');
        this.handleVariant = this.handleVariant.bind(this);
        this.handleNativeVariant = this.handleNativeVariant.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleQuantityChange = this.handleQuantityChange.bind(this);
        window.addEventListener('globoSwatchClickedVariantSwatch', this.handleVariant);
        this.productInfo?.addEventListener('change', this.handleInputChange, true);
        this.productInfo?.addEventListener('variant:change', this.handleNativeVariant);
        this.quantityInput = this.productInfo?.querySelector(`[name="quantity"][form="${this.dataset.formId}"]`);
        this.quantityInput?.addEventListener('input', this.handleQuantityChange);
        this.quantityInput?.addEventListener('change', this.handleQuantityChange);
      }

      disconnectedCallback() {
        window.removeEventListener('globoSwatchClickedVariantSwatch', this.handleVariant);
        this.productInfo?.removeEventListener('change', this.handleInputChange, true);
        this.productInfo?.removeEventListener('variant:change', this.handleNativeVariant);
        this.quantityInput?.removeEventListener('input', this.handleQuantityChange);
        this.quantityInput?.removeEventListener('change', this.handleQuantityChange);
      }

      handleInputChange(event) {
        if (!event.target.matches('.globo-swatch-product-detail input[type="radio"]')) return;
        this.handleVariant();
      }

      handleNativeVariant(event) {
        if (!event.detail?.variant) return;
        this.currentVariant = event.detail.variant;
        this.updateButtonPrice(event.detail.variant);
      }

      handleQuantityChange() {
        this.updateButtonPrice(this.currentVariant);
      }

      handleVariant() {
        const config = window.GloboSwatchConfig;
        const swatches = this.productInfo?.querySelectorAll('.globo-swatch-product-detail .swatch--gl');
        if (!config?.product?.variants || !swatches?.length) return;

        const options = Array.from(swatches, (swatch) => swatch.querySelector('input[type="radio"]:checked')?.value);
        if (options.some((option) => !option)) return;

        const variant = config.product.variants.find((item) => item.options.every((option, index) => option === options[index]));
        if (!variant || variant.id === this.variantId) return;
        this.variantId = variant.id;
        this.currentVariant = variant;
        variant.variant_state = { on_sale: Number(variant.compare_at_price) > Number(variant.price) };

        const form = document.forms[this.dataset.formId];
        const masterInput = form?.querySelector('[name="id"]');
        if (masterInput) masterInput.value = variant.id;
        if (this.dataset.productId) {
          document.querySelectorAll(`form[id*="${this.dataset.productId}"] [name="id"]`).forEach((input) => {
            input.value = variant.id;
          });
        }

        this.productInfo.querySelectorAll('hdt-price, hdt-compare-at-price, hdt-unit-price, hdt-qty-price').forEach((price) => {
          price.onVariantChanged?.({ detail: { variant } });
        });
        this.updateButtonPrice(variant);
      }

      updateButtonPrice(variant) {
        const priceElement = this.productInfo?.querySelector('[data-aurlona-atc-price]');
        if (!priceElement) return;

        const cents = Number(variant?.price ?? priceElement.dataset.variantPrice);
        if (!Number.isFinite(cents)) return;

        const quantity = Math.max(1, Number(this.quantityInput?.value) || 1);
        const currency = priceElement.dataset.currency || window.Shopify?.currency?.active || 'USD';
        const locale = priceElement.dataset.locale || document.documentElement.lang || 'en';
        const value = priceElement.querySelector('.aurlona-atc-price__value');

        try {
          value.textContent = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency
          }).format((cents * quantity) / 100);
        } catch (error) {
          value.textContent = `${currency} ${((cents * quantity) / 100).toFixed(2)}`;
        }

        priceElement.dataset.variantPrice = String(cents);
        priceElement.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-size-chart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('size-guide-tabs')) {
    customElements.define('size-guide-tabs', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this);
        this.addEventListener('keydown', this);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this);
        this.removeEventListener('keydown', this);
      }

      handleEvent(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        if (event.type === 'click') {
          this.activate(tab);
          return;
        }
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        let index = tabs.indexOf(tab);
        if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') index = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else return;
        event.preventDefault();
        this.activate(tabs[index]);
        tabs[index].focus();
      }

      activate(activeTab) {
        this.querySelectorAll('[role="tab"]').forEach((tab) => {
          const active = tab === activeTab;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active);
          tab.tabIndex = active ? 0 : -1;
          const panel = this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`);
          if (panel) panel.hidden = !active;
        });
      }
    });
  }

  if (!customElements.get('size-guide-relocator')) {
    customElements.define('size-guide-relocator', class extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('.hdt-product-info__list');
        this.addEventListener('click', this);
        if (!this.productInfo || this.place()) return;
        this.observer = new MutationObserver(() => this.place());
        this.observer.observe(this.productInfo, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this);
        this.observer?.disconnect();
      }

      handleEvent(event) {
        const button = event.target.closest('button[aria-controls]');
        if (!button) return;
        const dialog = document.getElementById(button.getAttribute('aria-controls'));
        if (!dialog?.parentElement) return;
        event.preventDefault();
        event.stopPropagation();
        const scrollbarWidth = Math.max(window.innerWidth - document.documentElement.clientWidth, 0);
        document.documentElement.style.setProperty('--scrollbar-w', `${scrollbarWidth}px`);
        dialog.btnOpening = button;
        dialog.open ? dialog.parentElement.close() : dialog.parentElement.open();
      }

      place() {
        const labels = this.dataset.sizeLabels.toLowerCase().split(',').map((label) => label.trim()).filter(Boolean);
        const targets = this.productInfo.querySelectorAll('.globo-swatch-product-detail legend.name-option, .hdt-product__variant-picker fieldset.is-style-size > legend');
        const target = Array.from(targets).find((element) => {
          if (element.getClientRects().length === 0) return false;
          const text = element.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
          return labels.some((label) => text === label || text.startsWith(`${label}:`));
        });
        if (!target) return false;
        if (this.parentElement === target) return true;
        target.classList.add('hdt-size-guide-target');
        target.append(this);
        this.observer?.disconnect();
        return true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
